/*****/
export const GET_CRS_CUSTOMER_LIST_DATA = 'GET_CRS_CUSTOMER_LIST_DATA';
export const GET_CRS_CUSTOMER_LIST_DATA_FAIL =
  'GET_CRS_CUSTOMER_LIST_DATA_FAIL';
export const GET_CRS_CUSTOMER_LIST_DATA_SUCCESS =
  'GET_CRS_CUSTOMER_LIST_DATA_SUCCESS';
/*****/
export const GET_CRS_SEGMENT_LIST_DATA = 'GET_CRS_SEGMENT_LIST_DATA';
export const GET_CRS_SEGMENT_LIST_DATA_FAIL = 'GET_CRS_SEGMENT_LIST_DATA_FAIL';
export const GET_CRS_SEGMENT_LIST_DATA_SUCCESS =
  'GET_CRS_SEGMENT_LIST_DATA_SUCCESS';
/****/
export const GET_CRS_CLUSTER_LIST_DATA = 'GET_CRS_CLUSTER_LIST_DATA';
export const GET_CRS_CLUSTER_LIST_DATA_SUCCESS =
  'GET_CRS_CLUSTER_LIST_DATA_SUCCESS';
export const GET_CRS_CLUSTER_LIST_DATA_FAIL = 'GET_CRS_CLUSTER_LIST_DATA_FAIL';
/*****/
export const GET_CRS_CUSTOMER_TYPE_LIST_DATA =
  'GET_CRS_CUSTOMER_TYPE_LIST_DATA';
export const GET_CRS_CUSTOMER_TYPE_LIST_DATA_FAIL =
  'GET_CRS_CUSTOMER_TYPE_LIST_DATA_FAIL';
export const GET_CRS_CUSTOMER_TYPE_LIST_DATA_SUCCESS =
  'GET_CRS_CUSTOMER_TYPE_LIST_DATA_SUCCESS';
/*****/
export const GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA =
  'GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA';
export const GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_FAIL =
  'GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_FAIL';
export const GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_SUCCESS =
  'GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_SUCCESS';

// Customer List Data

export const getCrsCustomerListData = (payload) => {
  return {
    type: GET_CRS_CUSTOMER_LIST_DATA,
    payload
  };
};

export const getCrsCustomerListDataSuccess = (payload) => {
  return {
    type: GET_CRS_CUSTOMER_LIST_DATA_SUCCESS,
    payload
  };
};

export const getCrsCustomerListDataFail = (payload) => {
  return {
    type: GET_CRS_CUSTOMER_LIST_DATA_FAIL,
    payload
  };
};

// Segment List Data

export const getCrsSegmentListData = (payload) => {
  return {
    type: GET_CRS_SEGMENT_LIST_DATA,
    payload
  };
};

export const getCrsSegmentListDataSuccess = (payload) => {
  return {
    type: GET_CRS_SEGMENT_LIST_DATA_SUCCESS,
    payload
  };
};

export const getCrsSegmentListDataFail = (payload) => {
  return {
    type: GET_CRS_SEGMENT_LIST_DATA_FAIL,
    payload
  };
};

// Cluster list data

export const getCrsClusterListData = (payload) => {
  return {
    type: GET_CRS_CLUSTER_LIST_DATA,
    payload
  };
};

export const getCrsClusterListDataSuccess = (payload) => {
  return {
    type: GET_CRS_CLUSTER_LIST_DATA_SUCCESS,
    payload
  };
};

export const getCrsClusterListDataFail = (payload) => {
  return {
    type: GET_CRS_CLUSTER_LIST_DATA_FAIL,
    payload
  };
};

// Customer Type List Data

export const getCrsCustomerTypeListData = (payload) => {
  return {
    type: GET_CRS_CUSTOMER_TYPE_LIST_DATA,
    payload
  };
};

export const getCrsCustomerTypeListDataSuccess = (payload) => {
  return {
    type: GET_CRS_CUSTOMER_TYPE_LIST_DATA_SUCCESS,
    payload
  };
};

export const getCrsCustomerTypeListDataFail = (payload) => {
  return {
    type: GET_CRS_CUSTOMER_TYPE_LIST_DATA_FAIL,
    payload
  };
};

// Risk Level Change List Data

export const getCrsRiskLevelChangeListData = (payload) => {
  return {
    type: GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA,
    payload
  };
};

export const getCrsRiskLevelChangeListDataSuccess = (payload) => {
  return {
    type: GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_SUCCESS,
    payload
  };
};

export const getCrsRiskLevelChangeListDataFail = (payload) => {
  return {
    type: GET_CRS_RISK_LEVEL_CHANGE_LIST_DATA_FAIL,
    payload
  };
};
